import React, { Component } from "react";
import PropTypes from "prop-types";
import { Group, Arc, Text, Image as KonvaImage } from "react-konva";

/**
 * @augments {Component<WheelItem.propTypes, {}>}
 */
class WheelItem extends Component {
    static propTypes = {
        radius: PropTypes.number,
        diameter: PropTypes.number,
        totalItems: PropTypes.number,

        /**
         * This must start from 1, not from 0. Why? because we will use this in the
         * calculation
         */
        index: PropTypes.number,

        data: PropTypes.shape({
            color: PropTypes.string,
            category_name: PropTypes.string,

            // URL to the image
            icon_image: PropTypes.oneOfType([PropTypes.string]),
        }),

        textStyle: PropTypes.object,
        isVertical: PropTypes.bool,
    };

    constructor(props) {
        super(props);
        this.state = {
            image: null,
            isLoaded: false,
            imageRatio: 1,
        };
    }

    componentDidMount() {
        if (!this.props.data.icon_image) return false;

        const self = this;

        /**
         * Why set image here instead of inside the render function? to make sure
         * it only load once, and not making any request anymore
         */
        let image = new Image();
        image.src = this.props.data.icon_image;

        // Set image while it's loaded, and it'll re-Draw canvas when image loaded
        image.onload = function (e) {
            self.setState({
                image: image,
                isLoaded: true,
                imageRatio: this.width / this.height,
            });
        };
    }

    render() {
        const rotation = (360 / this.props.totalItems) * this.props.index;
        const halfAngleRadius = Math.PI / this.props.totalItems;
        const halfAngleDeg = 360 / (this.props.totalItems * 2);

        // formula: 2πr
        const circumference = 2 * Math.PI * this.props.radius;

        const font_body = window.fonts?.body?.regular_font;

        if (
            font_body &&
            typeof font_body === "string" &&
            font_body !== "false"
        ) {
            const customFontsBody = new FontFace(
                "Custom Fonts Body",
                `url(${font_body})`,
            );

            customFontsBody
                .load()
                .then((loadedFace) => {
                    const fontSet = document["fonts"];
                    if (fontSet && typeof fontSet["add"] === "function") {
                        fontSet["add"](loadedFace);
                    }
                })
                .catch(() => {});
        }

        const customFont = "Custom Fonts Body";

        const text_color = this.props.data.text_color;
        const text_size = this.props.radius / 16;

        /**
         * Set width for the text, to prevent text overlap, 50% total width of
         * this circumference slice,
         * formula: (circumference / totalSlice) * 60%
         * latest update: revert back to 60 from 35 : https://www.pivotaltracker.com/story/show/188582083
         */
        const text_width = ((circumference / this.props.totalItems) * 60) / 100;
        const text_X = 0.55 * this.props.radius * Math.cos(halfAngleRadius);
        const text_Y_withIcon =
            0.5 * this.props.radius * Math.sin(halfAngleRadius);
        // prettier-ignore
        const text_Y_withoutIcon =
            0.62 * this.props.radius * Math.sin(halfAngleRadius);
        const text_Y = this.state.image ? text_Y_withIcon : text_Y_withoutIcon;

        const text_offsetX = text_width / 2;
        const text_offsetY = this.props.isVertical
            ? this.props.radius / 40
            : this.props.radius / 10;
        const text_rotation = this.props.isVertical
            ? 180 + halfAngleDeg
            : 90 + halfAngleDeg;
        const icon_size = this.props.radius / 4;
        const icon_width = icon_size * this.state.imageRatio;

        // Why X & Y equal to text calculation? somehow it's fit :)
        const icon_X = text_X;
        const icon_Y = text_Y;
        const icon_offsetX = icon_width / 2;
        const icon_offsetY = this.props.radius / 2.8;
        const icon_rotation = 90 + halfAngleDeg;

        return (
            <Group
                x={this.props.radius}
                y={this.props.radius}
                rotation={rotation}
                name={this.props.data.category_id.toString()}
                preventDefault={false}
            >
                <Arc
                    x={0}
                    y={0}
                    // innerRadius={this.props.radius / 2}
                    outerRadius={this.props.radius}
                    angle={360 / this.props.totalItems}
                    fill={this.props.data.color}
                    name={this.props.data.category_id.toString()}
                    preventDefault={false}
                />

                {this.state.image ? (
                    <KonvaImage
                        image={this.state.image}
                        rotation={icon_rotation}
                        x={icon_X}
                        y={icon_Y}
                        offset={{ x: icon_offsetX, y: icon_offsetY }}
                        width={icon_width}
                        height={icon_size}
                        name={this.props.data.category_id.toString()}
                        preventDefault={false}
                    />
                ) : null}
            </Group>
        );
    }
}

export default WheelItem;
